import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1cebcd65"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "ask-ans" }
const _hoisted_3 = { class: "ask" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, "问", -1))
const _hoisted_5 = { class: "ask-block" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "info" }
const _hoisted_8 = { class: "ans" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, "答", -1))
const _hoisted_10 = { class: "ans-block" }
const _hoisted_11 = { class: "cont" }
const _hoisted_12 = { class: "info" }
const _hoisted_13 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Collapse = _resolveComponent("Collapse")!
  const _component_Nodata = _resolveComponent("Nodata")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createBlock(_component_a_spin, {
    tip: "加载中...",
    spinning: _ctx.spinning
  }, {
    default: _withCtx(() => [
      ((_ctx.data || []).length)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
            _createElementVNode("ul", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, i) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: 'tzzhd' + i
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _hoisted_4,
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("p", _hoisted_6, [
                        _createVNode(_component_Collapse, {
                          content: item.BarQuesContent,
                          darkText: false
                        }, null, 8, ["content"])
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("span", null, _toDisplayString(item.BarQuesAuthor), 1),
                        _createElementVNode("span", null, _toDisplayString(item.CreateT), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("p", _hoisted_11, [
                        _createVNode(_component_Collapse, {
                          content: item.ReplyContent,
                          darkText: true
                        }, null, 8, ["content"])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("span", null, _toDisplayString(item.ReplyT), 1),
                        _createElementVNode("span", null, "来源：" + _toDisplayString(item.ReplyUser), 1)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("section", _hoisted_13, [
            _createVNode(_component_Nodata, {
              nodatadesc: _ctx.itemdata.title,
              isShowSJ: false
            }, null, 8, ["nodatadesc"])
          ]))
    ]),
    _: 1
  }, 8, ["spinning"]))
}